<template>
<div class="table-title row no-margin">
  <div class="col-lg-6 col-md-6 content-section-left no-padding">
    <div class="content-section" v-if="dispatch.consignee">
      <div class="content-list">
        <span class="content-list-title bold">{{dispatch.transporter.name}}</span>
      </div>

      <div class="content-list">
        <ul class="content-list-section">
          <li>{{dispatch.transporter.address}}</li>
          <li>{{dispatch.transporter.city}}</li>
          <li>{{dispatch.transporter.state}} - {{dispatch.transporter.pincode}}</li>
        </ul>
      </div>

      <div class="content-list">
        <ul class="content-list-section">
          <li class="step-title">
            <span class="step-title-bold">TOTAL WEIGHT/QUANTITY</span>
            <span class="step-title-normal">{{total_ton}}</span>
          </li>
        </ul>
      </div>

      <div class="content-list" v-if="dispatch.vehicle.number">
        <div class="content-list-link">
          <svgicon name="link" width="10" height="10" :original="true" />
          {{dispatch.vehicle.number}} </div>
      </div>

      <div class="content-list">
        <div class="content-list-link" v-if="dispatch.flow.sim_tracking" @click="enableMap">
          <svgicon name="locations" width="10" height="10" :original="true" />
          Location Tracking</div>
      </div>

    </div>
  </div>

  <div class="col-lg-6 col-md-6 content-section-right no-padding">
    <div class="content-section">
      <div class="content-list">
        <span class="content-list-title bold">{{dispatch.depot.name}}</span>
      </div>

      <div class="content-list">
        <ul class="content-list-section">
          <li class="step-title">
            <span class="step-title-bold">LOADING POINT </span>
            <span class="step-title-normal">{{dispatch.depot.city}}</span>
          </li>
          <li>{{dispatch.depot.address}}</li>
          <li>{{dispatch.depot.state}} - {{dispatch.depot.pincode}}</li>
        </ul>
      </div>


        <div class="dialog-window">
         <Dialog :visible.sync="showMap" width="40%">
          <div class="dialog-section">
           <div class="el-dialog__title align-left" v-if="!isMapLoading">Location Tracking</div>
           <div class="row-edit">
             <Spinner  v-if="isMapLoading" />
              <iframe v-if="!isMapLoading"
                :src="trackUrl" frameborder="0"
                style="border:0" width="100%" height="400px"/>
           </div>
          </div>
         </Dialog>
        </div>

      <!-- <div class="content-list">
        <ul class="content-list-section">
          <li class="step-title">
            <span class="step-title-bold">Unloaders</span>
            <span class="step-title-normal">Not avaliable</span>
          </li>
          <li class="step-title">
            <span class="step-title-bold">EXPECTED DATE </span>
            <span class="step-title-normal">30/06/2018 </span>
          </li>
        </ul>
      </div> -->
    </div>
  </div>
</div>
</template>
<script>
export default {
  props:
  {
    dispatch: Object,
    total_ton: String,
    loading: Boolean,
  },
  data() {
    return {
      isMapLoading: false,
      showMap: false,
    };
  },
  computed: {

    trackUrl() {
      const tripId = !this.loading &&
        this.dispatch.flow.sim_tracking && this.dispatch.flow.sim_tracking.trip_id;
      this.getLocation(tripId);
      // return `${track}${tripId}`;
      this.$session.set('tripId', tripId);
      return `${window.location.origin}/map`;
    },
  },
  methods: {
    enableMap() {
      this.showMap = true;
      const tripId = !this.loading &&
        this.dispatch.flow.sim_tracking && this.dispatch.flow.sim_tracking.trip_id;
      this.getLocation(tripId);
    },
    async getLocation(tripId) {
      this.isMapLoading = true;
      const result = await this.$store.dispatch('pod/location', { tripId });
      this.data = result;
      this.$session.set('mapData', result);
      this.isMapLoading = false;
    },
  },
};
</script>
<style lang='scss'>
@import "~@common/styles-shipper/settings";
.align-left{
  float: left;
  display: block
}
.material-list{
  input{
    padding: 4px 0px;
    outline: none;
    border: 0;
    border-bottom: 1px solid #ddd;
    text-align: center;
    display: block;
    width: 100%;
  }
}
.dispatch-content {
      border-top: 4px solid #000;
    margin-bottom: 120px;
    padding-bottom: 30px;
    background: #fff;
    padding: 20px;
    height: 100vh;
    width: 900px;
    margin-left: auto;
    margin-right: auto;
    .table-row {
        //padding-left: 15px;
        border-color: transparent;
    }

    .table-title {
        margin-bottom: 20px;
        border-bottom: 1px solid #ddd;
        padding: 10px 0;
        &-content {
            background: #F9FAFA;
            padding: 10px;
            border: 1px solid #EFEFEF;
        }
        .float-right {
            text-align: right;
        }
    }
    .content-section {
        &-left {
            float: left;
            display: inline-block;
        }
        &-right {
            float: right;
            display: inline-block;
            text-align: right;
        }
    }
    .content-list {
        line-height: 22px;
        &-link {
            color: #376F99;
            font-size: 1.2rem;
            font-family:$fontBold;
            padding: 8px 0;
            a{
              color: #376F99;
            }
        }
        &-section {
            @extend %list-unstyled;
            font-size: 1.0rem;
            li {
                line-height: 18px;
            }

            .step-title {
                margin: 5px 0;
                color: #404040;

                &-bold {
                    font-family:$fontBold;
                    font-size: 1.0rem;
                    text-transform: uppercase;
                }
                &-normal {
                    font-weight: normal;
                    font-size: 1.2rem;
                    padding-left: 10px;
                }
            }
        }
        .bold {
            font-family:$fontBold;
        }
        &-title {
            font-size: 1.4rem;
            color: #404040;

        }
    }
    .invoice-right-action {
        width: calc(100% - 550px);
        text-align: right;
        padding-right: 25px !important;
    }
}
</style>
